import { createDiagnosis } from "./create"
import { startDiagnosisSession } from "./start-session"
import { completeDiagnosis } from "./complete"
import { clickOnDiagnosisSubtheme } from "./click-on-subtheme"
export enum DIAGNOSES_EVENTS {
  CREATE_DIAGNOSIS = "User creates a diagnosis",
  START_DIAGNOSIS_SESSION = "User starts a diagnosis session",
  COMPLETE_DIAGNOSIS = "User completes a diagnosis",
  CLICK_ON_DIAGNOSIS_SUBTHEME = "User clicks on a diagnosis subtheme",
}

export const diagnoses = {
  create: createDiagnosis,
  startSession: startDiagnosisSession,
  complete: completeDiagnosis,
  clickOnDiagnosisSubtheme: clickOnDiagnosisSubtheme,
}
